import { render, staticRenderFns } from "./PanelistsSelector.vue?vue&type=template&id=6a8051ea"
import script from "./PanelistsSelector.vue?vue&type=script&lang=ts"
export * from "./PanelistsSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports